import React, { CSSProperties } from 'react'

export interface TailProps {
  color?: string
  size?: number
  style?: CSSProperties
}

export const MessageTail = ({
  size = 8,
  color = '#e5e5ea',
  style,
  ...props
}: TailProps) => {
  const width = (size * 8) / 7
  const height = size

  return (
    <div
      style={{
        position: 'relative',
        maxWidth: width,
        minWidth: width,
        minHeight: height,
        maxHeight: height,
        marginTop: 'auto',
      }}
    >
      <svg
        viewBox={`0 0 6 7`}
        style={style}
      >
        <path
          d="M0.707105 6.29289C0.0771399 6.92286 0.523309 8 1.41421 8L7 8L7 0L0.707105 6.29289Z"
          fill={color}
        />
      </svg>
    </div>
  )
}
